storefrontApp.service('membershipElasticService', function () {
    var ATG_BRAND = 'ann the gran';
    var SOURCE_INCLUDES = [
        'brand',
        'catalog',
        'name',
        'listPrice',
        'salePrice',
        'clubPrice',
        'itemId',
        'variants',
        'isBuyable',
        'definitionName',
        'saleRank',
        'yearCreated',
        'rating',
        'productType',
        'isClubOnly',
        'fileTypesAvailable',
        'colorSequence',
        'licensed',
        'patchUrl',
        'mainFeatures',
        'packageType'
    ];

    function buildClubBenefitProductsRequest(options) {
        var must = [
            { term: { brand: options.brand || ATG_BRAND } },
            { range: { listPrice: { gt: 0 } } },
            { range: { clubPrice: { gte: 0 } } }
        ];

        if (options.definitionName) {
            must.push({ term: { definitionName: options.definitionName } });
        }
        if (options.categoryKeyword) {
            must.push({ term: { 'categoriesList.keyword': options.categoryKeyword } });
        }

        return JSON.stringify({
            track_total_hits: true,
            query: {
                bool: { must: must }
            },
            size: options.size || 50,
            sort: [
                { yearCreated: { order: 'desc' } },
                { saleRank: { order: 'desc' } }
            ],
            _source: { includes: SOURCE_INCLUDES }
        });
    }

    this.buildClubPricesTotalRequest = function (productIds) {
        return (
            (req =
                '{"query":{"ids":{"values":["' +
                productIds +
                '"]}},"size":0,"aggs":{"items":{"top_hits":{"size":150,"_source":{"includes":["clubPrice","listPrice","salePrice","variants.variantId", "variants.listPrice", "variants.salePrice", "variants.clubPrice"]}}}}}')
        );
    };

    this.buildClubExclusiveFreeProductsRequest = function () {
        return (
            (req =
                '{"track_total_hits": true, "query":{"bool":{"must":[{"term":{"definitionName":{"value":"StockDesign"}}},{"range":{"listPrice":{"gt":0.1}}},{"range":{"clubPrice":{"lte":0}}}]}},"size":0,"aggs":{"free_products":{"terms":{"field":"definitionName"},"aggs":{"free_products":{"top_hits":{"sort":[{"yearCreated":{"order":"desc"}},{"saleRank":{"order":"desc"}}],"size":50,"_source":{"includes":["brand","catalog","name","listPrice","salePrice","clubPrice","itemId","variants","isBuyable","definitionName","saleRank","yearCreated","rating","productType","isClubOnly","fileTypesAvailable","colorSequence","licensed","patchUrl","mainFeatures","packageType"]}}}}}}}')
        );
    };

    // ATG design packs with club pricing (newest / popular first; client picks lowest club prices)
    this.buildAtgDesignPacksRequest = function (size) {
        return buildClubBenefitProductsRequest({
            definitionName: 'DesignPack',
            size: size || 50
        });
    };

    // ATG brand stabilizers (Supplies in stabilizers category)
    this.buildAtgStabilizersRequest = function (size) {
        return buildClubBenefitProductsRequest({
            definitionName: 'Supplies',
            categoryKeyword: 'stabilizers',
            size: size || 50
        });
    };

    // ATG fonts / Ann's Alphabets
    this.buildAtgFontsRequest = function (size) {
        return buildClubBenefitProductsRequest({
            definitionName: 'Font',
            size: size || 50
        });
    };
});
